export default "__VITE_ASSET__88d375bb__"